import { motion } from 'framer-motion';
import { TEAM } from './data';
export default function Team({ setPage }) {
  return (
    <div className="bg-[#F7E6E0] text-[#0A0A0A]">
      <section className="pt-32 pb-8 max-w-[1500px] mx-auto px-8 lg:px-14 border-b border-[#0A0A0A]/15">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#A8567A] mb-3">— Acte III / Stylistes</p>
        <h1 className="font-serif italic text-[44px] lg:text-[88px] leading-[0.95]">Trois stylistes, sept fauteuils.</h1>
      </section>
      <section className="max-w-[1500px] mx-auto px-8 lg:px-14 py-16 grid md:grid-cols-3 gap-px bg-[#A8567A]/15">
        {TEAM.map((t, i) => (
          <motion.div key={t.name} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.08 }} className="bg-[#F7E6E0] p-8 group">
            <div className="aspect-[3/4] overflow-hidden mb-5"><img src={t.img} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-1000" loading="lazy" /></div>
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#A8567A]">/ Styliste 0{i + 1}</p>
            <p className="font-serif italic text-3xl mt-1">{t.name}</p>
            <p className="font-serif italic text-base text-[#0A0A0A]/55 mt-1">{t.role}</p>
            <p className="text-sm text-[#0A0A0A]/65 mt-3 leading-[1.6]">{t.cred}</p>
            <button onClick={() => setPage('book')} className="mt-5 w-full bg-[#0A0A0A] text-[#F7E6E0] py-3 font-mono text-[10px] tracking-[0.3em] uppercase hover:bg-[#A8567A] transition-colors">Réserver avec {t.name.split(' ')[0]} →</button>
          </motion.div>
        ))}
      </section>
    </div>
  );
}
